import React, {Component} from 'react';
import {connect} from 'react-redux';

import {fetchMaestro} from '../../actions';
import PageHeader from '../../components/PageHeader';

import MaestroTreeNode from './MaestroTreeNode';
import './MaestroTreeCss.css';
import moment from "moment/moment";

class MantMaestros extends Component {

    static hideMessage() {
        document.getElementById('alert').style.display = 'flex';
        setTimeout(() => {
            if (document.getElementById('alert')) {
                document.getElementById('alert').style.display = 'none';
            }
        }, 5000);
    }

    constructor(props) {
        super(props);
        this.state = {
            maestros: [],
            filtroOpcion: '',
            filtro: '',
        };
        this.onChangeFiltro = this.onChangeFiltro.bind(this);
        this.onChangeFiltroOpcion = this.onChangeFiltroOpcion.bind(this);
    }

    componentDidMount() {
        this.props.fetchMaestro('', '');
       if (this.props && this.props.match && this.props.match.params && this.props.match.params.save === "ok" ) {
            this.setState({
                iconAlert: 'ion-close-circled',
                colorBackground: '#1DB89B',
                mensajeAlert: 'Se Ejecuto Correctamente'
            });
            MantMaestros.hideMessage();
        }
    }

    onChangeFiltro(e) {
        this.setState({filtro: e.target.value});

        if(this.state.filtroOpcion === "pc")
            this.props.fetchMaestro(e.target.value, '');
        else{
            this.props.fetchMaestro('', e.target.value);
        }
    }

    onChangeFiltroOpcion(e) {
        this.setState({filtroOpcion: e.target.value, filtro: ''});
        this.props.fetchMaestro('', '');
    }

    renderArrayToTree = (_array) => {
        let tree = [],
            mappedArr = {},
            arrElem, mappedElem;

        for (let i = 0, len = _array.length; i < len; i++) {
            arrElem = _array[i];
            mappedArr[arrElem.codGrupo + '-' + arrElem.codTipo] = arrElem;
            mappedArr[arrElem.codGrupo + '-' + arrElem.codTipo]['id'] = arrElem.codGrupo + '-' + arrElem.codTipo;
        }

        for (let id in mappedArr) {
            if (mappedArr.hasOwnProperty(id)) {
                mappedElem = mappedArr[id];
                mappedElem['codGrupoRec'] = mappedElem['codGrupoRec'] === null ? 0 : mappedElem['codGrupoRec'];
                mappedElem['codTipoRec'] = mappedElem['codTipoRec'] === null ? 0 : mappedElem['codTipoRec'];
                if (mappedElem.codGrupoRec !== 0 && mappedElem.codTipoRec !== 0) {
                    if (mappedArr[mappedElem['codGrupoRec'] + '-' + mappedElem['codTipoRec']] !== undefined) {
                        if (mappedArr[mappedElem['codGrupoRec'] + '-' + mappedElem['codTipoRec']]['children'] === undefined) {
                            mappedArr[mappedElem['codGrupoRec'] + '-' + mappedElem['codTipoRec']]['children'] = [];
                        }
                        mappedArr[mappedElem['codGrupoRec'] + '-' + mappedElem['codTipoRec']]['children'].push(mappedElem);
                    }
                } else {
                    tree.push(mappedElem);
                }
            }
        }
        return tree;
    };

    render() {

        const {maestros} = this.props;

        const dataMaestroTree = maestros.tablaMaestroList === undefined ? [] : this.renderArrayToTree(maestros.tablaMaestroList);

        return (
            <div>
                <PageHeader title='Mantenimiento de Maestros' buttonName='Nuevo maestro'
                            link={'/mantenimiento-maestros/nuevo'}/>
                <div className='pageHead-rowContainer'>
                    <div className='pageHead-filters wrapper'>
                        <div className='pageHead-filters-search'>
                            <div className='fSearch'>
                                <div className='fSearch-filter form-control'>
                                    <select value={this.state.filtroOpcion} onChange={this.onChangeFiltroOpcion}>
                                        <option value='pd'>Descripción</option>
                                        <option value='pc'>Código Grupo</option>
                                    </select>
                                </div>

                                <input
                                    type='text'
                                    className='fSearch-search form-control checkDeGrillaEnterCerrar'
                                    value={this.state.filtro}
                                    onChange={this.onChangeFiltro}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='wrapper'>
                    <div className='tableWrapper'>
                        {
                            dataMaestroTree ?
                                dataMaestroTree.map(child => (
                                    <MaestroTreeNode key={child.id} data={child}/>
                                )) :
                                ''
                        }
                    </div>
                </div>
                <div className='alert alert-warning' role='alert' id='alert'
                     style={{display: 'none', zIndex: '2000', backgroundColor: this.state.colorBackground}}>
                    <i className={this.state.iconAlert}/>
                    <p>{this.state.mensajeAlert}</p>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        maestros: state.maestros,
    };
}

MantMaestros.defaultProps = {
    maestros: []
};

export default connect(
    mapStateToProps,
    {
        fetchMaestro
    }
)(MantMaestros);



// WEBPACK FOOTER //
// ./src/pages/MantMaestros/MantMaestros.js